module.exports = __webpack_public_path__ + "static/media/mail.bdee0336.svg";